import { render } from "./TheUserMenu.vue?vue&type=template&id=a4728412&scoped=true&ts=true"
import script from "./TheUserMenu.vue?vue&type=script&lang=ts"
export * from "./TheUserMenu.vue?vue&type=script&lang=ts"

import "./TheUserMenu.vue?vue&type=style&index=0&id=a4728412&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4728412"]])

export default __exports__